<template>
	<div class="wizard-navigation">
		<div class="progress-with-circle">
			<div class="progress-bar"
				role="progressbar"
				aria-valuenow="1"
				aria-valuemin="1"
				aria-valuemax="5"
				:class="{
					'width10': step == 1,
					'width30': step == 2,
					'width50': step == 3,
					'width70': step == 4,
					'width90': step == 5
				}">

			</div>
		</div>

		<ul class="nav nav-pills pli-nav-pills">
			<li :class="{'active' : step == 1 }">
				<a
					href="#"
					@click.prevent="handleGoto(1)"
					:class="{
						'wizard-navigation-item': true,
						'wizard-navigation-item__checked': step > 1,
					}"
				>
					<div class="icon-circle checked">
						<i class="ti-check-box"></i>
					</div>
					Work Overview
				</a>
			</li>
			<li :class="{'active' : step == 2 }">
				<a
					href="#"
					@click.prevent="handleGoto(2)"
					:class="{
						'wizard-navigation-item': true,
						'wizard-navigation-item__checked': step > 2,
					}"
				>
					<div class="icon-circle" :class="{'checked' : step > 1}">
						<i class="ti-user"></i>
					</div>
					Your Details
				</a>
			</li>
			<li :class="{'active' : step == 3 }">
				<a
					href="#"
					@click.prevent="handleGoto(3)"
					:class="{
						'wizard-navigation-item': true,
						'wizard-navigation-item__checked': step > 3,
					}"
				>
					<div class="icon-circle" :class="{'checked' : step > 2}">
						<i class="ti-money"></i>
					</div>
					Select An Insurer
				</a>
			</li>
			<li :class="{'active' : step == 4 }">
				<a
					href="#"
					@click.prevent="handleGoto(4)"
					:class="{
						'wizard-navigation-item': true,
						'wizard-navigation-item__checked': step > 4,
					}"
				>
					<div class="icon-circle" :class="{'checked' : step > 3}">
						<i class="ti-lock"></i>
					</div>
                    Additional Questions
				</a>
			</li>
            <li :class="{'active' : step == 5 }">
				<a
					href="#"
					@click.prevent="handleGoto(5)"
					:class="{
						'wizard-navigation-item': true,
						'wizard-navigation-item__checked': step > 5,
					}"
				>
					<div class="icon-circle" :class="{'checked' : step > 4}">
						<i class="ti-credit-card"></i>
					</div>
					Checkout
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import store from '../store'

	export default {
		store,

		props: {
			step: {
				type: Number,
				required: true
			}
		},
		methods: {
			...mapActions([
				'scrollToTop',
			]),

			handleGoto (toStep) {
				if (toStep >= this.step) {
					return
				}

				this.$root.$emit('gotostep', toStep)
				this.$store.commit('setStep', { step: toStep })
				this.$store.commit('clearError')
				this.scrollToTop()
			},
		},
	}
</script>

<style lang="scss">
.wizard-navigation {
	z-index: 0;

	&-item {
		pointer-events: none;
		cursor: none;

		&__checked {
			pointer-events: all;
			cursor: pointer;
		}
	}
	
	.nav{
		justify-content: space-around;
	}
}


.wizard-card {
		.nav-pills > li.active > a:after{
			left: -35px;
		}
	}

@media screen and (max-width: 768px) {
	.wizard-card {
		.icon-circle {
			width: 50px;
			height: 50px;

			i {
				line-height: 0.55;
			}
		}

		.nav-pills {
			> li {
				top: 10px;

				a {
					.icon-circle {
						font-size: 16px;
					}
				}

				&.active > a:after {
					background-color: rgba(0,169,157, .5);
					width: 50px !important;
					height: 50px !important;
					left: -25px !important;
				}
			}
		}
	}
}
</style>
